import { render, staticRenderFns } from "./UTMLinks.vue?vue&type=template&id=2d17c3f8&scoped=true&"
import script from "./UTMLinks.vue?vue&type=script&lang=js&"
export * from "./UTMLinks.vue?vue&type=script&lang=js&"
import style0 from "./UTMLinks.vue?vue&type=style&index=0&id=2d17c3f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d17c3f8",
  null
  
)

export default component.exports